import { render, staticRenderFns } from "./EditSchoolContact.vue?vue&type=template&id=0dbc2109&scoped=true&"
import script from "./EditSchoolContact.vue?vue&type=script&lang=js&"
export * from "./EditSchoolContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbc2109",
  null
  
)

export default component.exports